const cca_config = {
    VUE_APP_NAME: 'AFIA DON BOSCO | Caisse',
    MODULE: {
        clinique: {
            port: '',  // ne pas oublier  les deux points (:),
            name: ''
        },
        caisse: {
            port: ''  // ne pas oublier  les deux points (:)
        },
        stock: {
            port: ''  // ne pas oublier  les deux points (:)
        },
        rh: {
            port: ''  // ne pas oublier  les deux points (:)
        },
    },
    C_URL: 'https://tcca-api.clinicaa-erp.com',
    
    C_CLINIQUE_FE_URL: 'https://tcca-clinique.clinicaa-erp.com',
    C_CAISSE_FE_URL: 'https://tcca-caisse.clinicaa-erp.com',
    C_STOCK_FE_URL: 'https://tcca-stock.clinicaa-erp.com',
    C_RH_FE_URL: 'https://tcca-rh.clinicaa-erp.com',

    C_URL_CLINIQUE_API: '/tcca/be_clinique/public/index.php/api',
    C_URL_CAISSE_API: '/tcca/be_caisse/public/index.php/api',
    C_URL_CONFIG_API: '/tcca/be_config/public/index.php/api',
    C_URL_STOCK_API: '/tcca/be_stock/public/index.php/api',

    C_URL_ASSET: '/tcca/be_clinique/assets',
    C_URL_CAISSE_ASSET: '/tcca/be_caisse/assets',
    COUNTRY_CODE: 'cd',
    VILLE: 'Lubumbashi',
    FOOT_1: '',
    FOOT_2: '',
    FOOT_ORD: '',
    PDL_PAPIER_ENTETE: '',              //  Marge intérieure gauche du papier entete
    TYPE_CLINIQUE: 'Clinique',
    NOM_CLINIQUE: 'POLYCLINIQUE AFIA DON BOSCO',
    IS_SFE: false,
    CAN_SET_PAC: true,
    IS_MODELE_ANALYSE: true,
    PRINCIPAL_CURRENCY: 'Franc congolais',
    SECONDARY_CURRENCY: 'Dollar américain',
    CURRENCY_LANG: 'fr-FR',
    HAS_TWO_CURRENCIES: true
}
export { cca_config }